import { ISOCode } from 'src/components/molecules/WorldMap/worldMap.types';

export interface DropDownItemsStoreType {
  region: DropDownItemsRegion[];
  country: DropDownItems[];
  sector: DropDownItems[];
  sector2: DropDownItems[];
  typeOfProjectPartner: DropDownItems[];
}

export interface DropDownItems {
  key: string;
  value: string;
}

export interface DropDownItemsRegion extends DropDownItems {
  isoCodes: ISOCode[];
}

export enum DropDownItemsStoreKind {
  INITIAL = 'INITIAL',
}

export interface DropDownItemsStoreAction {
  type: DropDownItemsStoreKind.INITIAL;
  payload: DropDownItemsStoreType;
}
